import React from "react";
import styles from "./Splash.module.scss";
import logo from "../../assets/img/vantage90_logo_inline.svg";
import splash from "../../assets/img/vantage90_splash.svg";

const Splash = ({ children, isWide }) => {
  return (
    <div className={styles.container}>
      <div className={styles.splash}>
        <div className={styles.splashOverlay}>
          <img src={logo} alt="Vantage90 Logo" className={styles.img} />
        </div>
        <img src={splash} alt="splash" className={styles.svg} />
      </div>
      <div className={isWide ? styles.contentWide : styles.content}>{children}</div>
    </div>
  );
};

export default Splash;
